var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"platinum"}},[_c('v-container',[_c('v-img',{attrs:{"src":require('../assets/platinum.jpg'),"contain":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }